import { Injectable } from '@angular/core';
import { Location } from "@angular/common";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class LoggingService {

    constructor(
        protected http: HttpClient,
        private location: Location
    ) { 
        this.baseUrl = this.location.prepareExternalUrl("/");
    }

    private baseUrl: string; 

    // Skicka meddelande till appcenter
    logException(message: string): void {
        try {
            console.log(message);
            this.http.get( this.baseUrl + "LogException?errorMessage=" + message );
        } catch (e) {
            console.log(e);
        }
    }
}
